module.exports = __webpack_public_path__ + "img/KP.0b58e12a.png";